<button
  mat-stroked-button
  color="default"
  class="actions-menu-button"
  [matMenuTriggerFor]="balanceOverviewMenu"
>
<span class="flex align-items-center"><mat-icon class="material-icons">more_vert</mat-icon>ACTIONS<mat-icon class="material-icons">expand_more</mat-icon></span>

</button>
<mat-menu #balanceOverviewMenu="matMenu" xPosition="before">
  <button (click)="editAccount()" mat-menu-item>
    <mat-icon class="menu-icon material-icons-rounded">edit</mat-icon>
    <span>Edit Account</span>
  </button>

  <button (click)="disconnectAccount()" mat-menu-item>
    <mat-icon class="menu-icon" fontSet="material-icons-outlined">link_off</mat-icon>
    <span>Disconnect Account</span>
  </button>
</mat-menu>
